import React, { useState, useRef, useEffect } from "react";
import { DropDownButtonComponent } from "react";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  Nav,
  NavItem,
  InputGroup,
  InputGroupText,
  CardHeader,
  Card,
} from "reactstrap";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import Calendar from "assets/icon/calendar-icon.svg";
import CoveredEntity from "components/CoveredEntity";
import { Field, Formik, setNestedObjectValues } from "formik";
import { NavLink } from "react-router-dom";
import FormikInputField from "components/common/Fields/FormikInputField";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import useContextService from "hooks/useContextService";
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import useAxios from "hooks/useAxios";
import { cloneDeep, find, values } from "lodash";
import * as Yup from "yup";
import Select from "react-select";
import CustomReportsDate from "pages/Reports/customeReportsDate";
import moment from "moment";
import Pharmacy from "components/Pharmacy";
import { default as ReactSelect } from "react-select";
import { Option, LimitedChipsContainer } from "components/Options";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";

// const validationSchema = Yup.object({
//   reportType: Yup.string().required("Report is required"),
//   thirdPartyAdminID: Yup.string().required(
//     "Third party Administrator is required"
//   ),
// });

const reportOpt = [
  { id: 1, label: "Claims" },
  { id: 2, label: "Replenished Claims" },
  // { id: 3, label: "Non-Replenished Claims" },
  // { id: 4, label: "Invoiced Claims" },
  { id: 5, label: "Purchase Order Details" },
  { id: 6, label: "Non-Derived Claims" },
];

let hasDatePopupOpen = false;

const dateRangeOption = [
  {id: 0, label: "(All)"},
  { id: 1, label: "Current Month" },
  { id: 2, label: "Last Month" },
  { id: 3, label: "Last 30 days" },
  { id: 4, label: "Last 90 days" },
  { id: 5, label: "Last 180 days" },
  { id: 6, label: "Custom" },
];
const claimTypeOpt = [
  { Code: "all", ClaimType: "(All)", Id: 0 },
  { Code: "Captured", ClaimType: "Captured", Id: 9002 },
  { Code: "Non Captured", ClaimType: "Non-Captured", Id: 9003 },
];
const statusTypesOpt = [
  { Code: "REP", StatusType: "(All)", Id: 0 },
  { Code: "REP", StatusType: "Replenished", Id: 1 },
  { Code: "NREP", StatusType: "Non-Replenished", Id: 2 },
];
let ceData = [];
let pharmacyData = [];
let startDateError = '';
let endDateError = '';
let tpaError = '';
let reportsError = '';
const SearchReports = (props) => {
  const [active, setActive] = useState("3");
  const [disable, setdisable] = useState(false);
  const [rangeDisable, setRangeDisable] = useState(false);
  const [searchCEterm, setSearchCEterm] = useState("");
  const [searchPHterm, setSearchPHterm] = useState("");
  const [selectedPH, setSelectedPH] = useState(null);
  const [ceDatalist, setCeDatalist] = useState([]);
  const [dateRangeValue, setDateRangeValue] = useState(0);
  const [selectedReportType, setReportTypeSelected] = useState(1);
  const [displayCustomDate, setDisplayCustomDate] = useState(false);
  const [selectedOption, setOptionSelected] = useState({
    optionSelected: "-1",
  });
  const [statusTypeSelected, setStatusTypeSelected] = useState(0);
  const [selectedOpt, setOptSelected] = useState({ optSelected: "-1" });
  const API = useAxios();
  const formikRef = useRef();
  const {
    states: { reports },
    setStates,
    resetStates,
  } = useContextService();
  const { search } = reports;
  const { onSearch, onReset, loading } = props;
  const {
    thirdPartyAdmin,
    coveredEntities,
    searchTerms,
    coveredEntity,
    pharmacy,
  } = reports;
  const {
    thirdPartyAdminID,
    pharmacyIDs,
    reportType,
    dateRange,
    startDate,
    endDate,
    claimTypeId,
    statusTypeId
  } = searchTerms;

  const [dateRanges, setDateRange] = useState([null, null]);
  const [selectedClaimType, setClaimTypeSelected] = useState(0);
  const[enddatevalue,setEndDateValue]=useState(null)

  const { tenantID } = thirdPartyAdmin;

  const updateStates = (reports) => {
    setStates("reports", reports);
  };

  useEffect(() => {
    reports.thirdPartyAdmin = {};
    reports.coveredEntities = [];
    reports.coveredEntity = {};
    reports.pharmacy = {};
    reports.SelectedReportType = {};
    reports.selectedDateRange = {};
    setDateRange([null, null]);
    setRangeDisable(false);
    setdisable(false);
    resetStates("reports");
    startDateError = '';
    endDateError = '';
    tpaError = '';
    reportsError = '';
    setReportTypeSelected(1);
    setDateRangeValue(0);
    setClaimTypeSelected(0);
    setdateRangeDates(0)

  }, []);

  const handleDateRangeChange = ({ target: { value } }) => {
    reports.searchTerms.startDate = "";
    reports.searchTerms.endDate = "";
    setEndDateValue(null)
    startDateError = '';
    endDateError = '';
    setDisplayCustomDate(false)
    setDateRangeValue(0)
    if (value) {
      const statusID = parseInt(value);
      const findObj = find(dateRangeOption, {
        id: statusID,
      });
      reports.selectedDateRange = findObj;
      reports.searchTerms.dateRange = findObj.id;
      setdisable(true);
      setdateRangeDates(findObj.id);
    } else {
      searchTerms.startDate = "";
      searchTerms.endDate = "";
      reports.selectedDateRange = {};
      reports.searchTerms.dateRange = '';

      setDisplayCustomDate(false)
      setDateRangeValue(0);
      setdisable(false);
    }
    updateStates(reports);

  };


  const setdateRangeDates = (val) => {
    let m = moment();
    setDateRangeValue(val);
    reports.searchTerms.endDate = m.format("MM/DD/yyyy");
    if(val == 0)
    {
      reports.searchTerms.startDate = '';
      reports.searchTerms.endDate = '';
      reports.startDate = '';
      reports.endDate = '';
      setEndDateValue(null)
    }//all
    if (val == 1) {
      let startDate = moment().startOf('month').format("MM/DD/yyyy");
      let endDate = moment().format("MM/DD/yyyy");

      reports.searchTerms.startDate = startDate;
      reports.searchTerms.endDate = endDate;
      reports.startDate = startDate ;
      reports.endDate = endDate ;

      startDateError = '';
      endDateError = '';
    }//current month
    if (val == 2) {
      let startDate = moment().subtract(1, 'months').startOf('month').format("MM/DD/yyyy");
      let endDate = moment().subtract(1, 'months').endOf('month').format("MM/DD/yyyy");

      reports.searchTerms.startDate = startDate;
      reports.searchTerms.endDate = endDate;

      startDateError = '';
      endDateError = '';
    }//lastmonth

    if (val == 3) {
      let startDate = m.subtract(29, "days").format("MM/DD/yyyy");
      reports.searchTerms.startDate = startDate;
      startDateError = '';
      endDateError = '';
    }//30 days
    if (val == 4) {
      let startDate = m.subtract(89, "days").format("MM/DD/yyyy");
      reports.searchTerms.startDate = startDate;
      startDateError = '';
      endDateError = '';
    }//90 days
    if (val == 5) {
      let startDate = m.subtract(179, "days").format("MM/DD/yyyy");
      reports.searchTerms.startDate = startDate;
      startDateError = '';
      endDateError = '';
    }// 180 days 
   
    if (val == 6) {
      setDisplayCustomDate(true)
      reports.searchTerms.startDate = "";
      reports.searchTerms.endDate = "";
      setEndDateValue(null)
    }//custom 
  };

  const handlepharmacyChange = (selected) => {
    setOptSelected({
      optSelected: selected,
    });
    if(selected.pharmacyIDs == 0)
    {
      reports.searchTerms.pharmacyids = [];
    }
    else
    {
    reports.searchTerms.pharmacyids = selected;
    }
    updateStates(reports);
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };


  const handleSubmit = async (val, actions) => {
    let coveredEntityIDS = [];
    for (var x in selectedOption.optionSelected) {
      var rw = selectedOption.optionSelected[x];
      coveredEntityIDS.push(rw.value);
    }
    let pharmacyIDs = [];
    for (var x in selectedOpt.optSelected) {
      var rw = selectedOpt.optSelected[x];
      pharmacyIDs.push(rw.value);
    }
    const { setSubmitting } = actions;
    const values = cloneDeep(val);

    if (dateRangeValue == 6 && (startDate == "" || reports.searchTerms.startDate == "")) { startDateError = "Start date is required" }
    if (dateRangeValue == 6 && (endDate == "" || reports.searchTerms.endDate == "")) { endDateError = "End date is required" }
    if (!thirdPartyAdminID) {
      tpaError = "Third party Administrator is required";
    }
    if (!reportType) {

      reportsError = "Report is required";
    }
    if (thirdPartyAdminID) values.thirdPartyAdminID;
    if (pharmacyIDs > [0]) values.pharmacyIDs = pharmacyIDs;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;

    // if (reports.searchTerms.startDate && dateRangeValue === 6) {
    //   values.startDate = startDate ? startDate : "";
    // }
    // if (reports.searchTerms.endDate && dateRangeValue === 6) {
    //   values.endDate = endDate ? endDate : "";
    // }
    if (reports.searchTerms.startDate) values.startDate = endDate == null ? "" : startDate;
    if (reports.searchTerms.endDate) values.endDate = endDate == null ? "" : endDate
    reports.search.currentPage = 1;
    reports.search.pageSize = 10;
    reports.search.order = 'desc';
    reports.search.orderBy = 'createdDate'
    values.claimTypeId = selectedClaimType;
    values.reportType = selectedReportType;
    values.statusTypeId = statusTypeSelected;
    values.dateRangeID = dateRangeValue;
    updateStates(reports);
    if (tpaError.length > 0 || reportsError.length > 0 || startDateError.length > 0 || endDateError.length > 0) {
      return
    }
    else { await onSearch(values); }

    setSubmitting(false);
  };
  const handleThirdPartyAdminChange = async (value, setFieldValue, tpa) => {
    pharmacyData = [];
    ceData = [];
    reports.coveredEntities = [];
    reports.coveredEntity = {};
    reports.pharmacy = {};
    setOptionSelected({ optionSelected: "-1" });
    setCeDatalist([]);
    reports.searchTerms.ceIds = {};
    reports.searchTerms.pharmacyids = {};
    setOptSelected({ optSelected: "-1" });
    const { thirdPartyAdminID } = tpa;
    fetchCoveredEntities(thirdPartyAdminID);
    fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    if (tpa) {
      tpaError = '';
      const { thirdPartyAdminID } = tpa;
      setFieldValue("thirdPartyAdminID", value);
      reports.coveredEntity = null;
      reports.pharmacy = "";
      reports.searchTerms.pharmacyIDs = [];
      reports.thirdPartyAdmin = tpa;
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
      reports.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
    } else {
      tpaError = "Third party Administrator is required";
      setFieldValue("thirdPartyAdminID", "");
      reports.coveredEntity = null;
      reports.pharmacy = "";
      reports.searchTerms.pharmacyIDs = [];
      reports.thirdPartyAdmin = {};
      reports.searchTerms.thirdPartyAdminID = "";
    }
    updateStates(reports);
  };

  const fetchPharmacyNamesByTpaID = async (thirdPartyAdminID) => {
    pharmacyData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/GetPharmaciesByTpaId/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if (data) {
        for (var x in data) {
          ceData.push({ value: data[x].id, label: data[x].description });
        }
        setCeDatalist(ceData);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const fetchPharmacyNames = async (selected) => {
    let payloads = [];
    pharmacyData = [];
    for (var x in selected) {
      var rw = selected[x];
      payloads.push(rw.value);
    }
    let payload = {};
    payload.CoveredIDS = payloads;
    try {
      const { data } = await API.post(
        `GWConfig/coveredentity/Pharmacieslist/${thirdPartyAdminID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      console.log(data);
      if (data) {
        for (var x in data) {
          if (!pharmacyData.some(item => item.value === data[x].pharmacyID)) {
            pharmacyData.push({
              value: data[x].pharmacyID,
              label: data[x].pharmacyName,
            });
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleCEChange = (selected) => {
    if (selected.length !== 0) {
      setOptSelected({
        optSelected: -1,
      });
    }
    if (selected.length === 0) {
      reports.searchTerms.ceIds = []
      fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    }
    else
    {
      reports.searchTerms.ceIds = selected;
      reports.searchTerms.pharmacyids = [];
    }
    pharmacyData = [];
    setOptionSelected({
      optionSelected: selected,
    });
   
    updateStates(reports);
    fetchPharmacyNames(selected);
  };

  const getDate = () => {
    const [startDate, endDate] = dateRanges;
    reports.searchTerms.startDate = startDate == null ? null : moment(startDate).format("MM/DD/yyyy");
    reports.searchTerms.endDate = endDate == null ? null : moment(endDate).format("MM/DD/yyyy");
    updateStates(reports);
  };

  const handleReportType = ({ target: { value } }, setFieldValue) => {
    updateStates(reports);
    setClaimTypeSelected(0);
    setStatusTypeSelected(0) ;
    setDateRangeValue(0);
    setDisplayCustomDate(false)
    if (value) {
      reportsError = "";
      const statusID = parseInt(value);
      const findObj = find(reportOpt, {
        id: statusID,
      });
      setFieldValue("reportType", statusID);
      reports.SelectedReportType = findObj;
      reports.searchTerms.reportType = findObj.id;
      reports.selectedReportType = findObj;
      reports.searchTerms.reportType = findObj.id;
      reports.search.currentPage = 1;
      reports.dateRange = {};
      reports.selectedDateRange = {};
      reports.searchTerms.dateRange = "";
      reports.searchTerms.startDate = "";
      reports.searchTerms.endDate = "";
      setEndDateValue(null)
      setReportTypeSelected(findObj.id);
      setDateRangeValue(0);
      setDisplayCustomDate(false)

    }
    else {
      reportsError = "Report is required";
      setFieldValue("reportType", "");
      reports.SelectedReportType = {};
      reports.searchTerms.reportType = null;
      reports.searchTerms.claimTypeId = null;
      setReportTypeSelected(1);
      setClaimTypeSelected(0);

    }
    updateStates(reports);
  };
  const handleClaimType = ({ target: { value } }, setFieldValue) => {
    if (value) {
      const statusID = parseInt(value);
      const findObj = find(claimTypeOpt, {
        Id: statusID,
      });

      setFieldValue("claimTypeId", statusID);
      reports.selectedClaimType = findObj;
            reports.claimTypeId = findObj.Id;

      reports.searchTerms.claimTypeId = findObj.Id;
      setClaimTypeSelected(findObj.Id);
    } else {
      setFieldValue("claimTypeId", "");
      reports.selectedClaimType = {};
      reports.searchTerms.claimTypeId = null;
      setClaimTypeSelected(0);
    }
    updateStates(reports);
  }
  const handleStatusType = ({ target: { value } }, setFieldValue) => {
    if (value) {
      const statusID = parseInt(value);
      const findObj = find(statusTypesOpt, {
        Id: statusID,
      });
      setFieldValue("statusTypeId", statusID);
      reports.selectedStatusType = findObj;
            reports.statusTypeId = findObj.Id;

      reports.searchTerms.statusTypeId = findObj.Id;
      setStatusTypeSelected(findObj.Id);
    } else {
      setFieldValue("statusTypeId", "");
      reports.selectedStatusType = {};
      reports.searchTerms.statusTypeId = null;
      setStatusTypeSelected(0);
    }
    updateStates(reports);
  };
  const handleReset = ({ resetForm }) => {
    search.filters = [];
    pharmacyData = [];
    ceData = [];
    reports.coveredEntities = [];
    reports.coveredEntity = {};
    reports.pharmacy = {};
    reports.SelectedReportType = {};
    reports.selectedDateRange = {};
    setDisplayCustomDate(false)
    setOptionSelected({ optionSelected: "-1" });
    setCeDatalist([]);
    setDateRange([null, null]);
    reports.searchTerms.ceIds = {};
    reports.searchTerms.pharmacyids = {};
    setEndDateValue(null)
    setRangeDisable(false);
    setDateRangeValue(0);
    setdisable(false);
    resetForm();
    setReportTypeSelected(1);
    setClaimTypeSelected(0);
    setStatusTypeSelected(0);
    // setdateRangeDates(false);
    onReset();
    resetStates("reports");
    setOptSelected({ optSelected: "-1" });
    startDateError = '';
    endDateError = '';
    tpaError = '';
    reportsError = '';
  };
  const findCE = async (value) => {
    setSearchCEterm(value);
  };
  const findPH = async (value) => {
    setSearchPHterm(value);
  };
  useEffect(() => {
    pharmacyData = [];
    // handleDateRangeChange("1");
  }, [])
  useEffect(() => {
    search.filters = [];
    pharmacyData = [];
    ceData = [];
    reports.coveredEntities = [];
    reports.coveredEntity = {};
    reports.pharmacy = {};
    reports.SelectedReportType = {};
    reports.selectedDateRange = {};
    setOptionSelected({ optionSelected: "-1" });
    setCeDatalist([]);
    setDateRange([null, null]);
    setStatusTypeSelected(0);
    setDateRangeValue(0);
    reports.searchTerms.ceIds = {};
    reports.searchTerms.pharmacyids = {};
    setRangeDisable(false);
    setdisable(false);
    onReset();
    resetStates("reports");
    setOptSelected({ optSelected: "-1" });
    startDateError = '';
    endDateError = '';
  }, [])


  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    if (startDate) {
      startDateError = '';
      reports.searchTerms.startDate = moment(new Date(startDate)).format("MM/DD/YYYY");
      if (reports.searchTerms.endDate && new Date(reports.searchTerms.endDate) < new Date(startDate)) {
        reports.searchTerms.endDate = '';
        setEndDateValue(null)
      }
    }
    else {
      startDateError = "Select a Start Date"
    }
    updateStates(reports);
  };

  const handleEndDate = (endDate) => {
    if (endDate) {
      endDateError = '';
      reports.searchTerms.endDate = moment(new Date(endDate)).format(
        "MM/DD/YYYY 23:59:59"
      );
      setEndDateValue( moment(new Date(endDate)).format(
        "MM/DD/YYYY"
      ))
    } else {
      endDateError = "Select an End Date "
    }
    updateStates(reports);

  };


  return (
    <Formik
      innerRef={formikRef}
      initialValues={searchTerms}
      onSubmit={handleSubmit}
      // validationSchema={validationSchema}
      enableReinitialize={true}
      children={(props) => {
        const { isSubmitting, handleSubmit, resetForm, setFieldValue } = props;

        return (
          <div>
            <h5 className="f-16 text-primary font-weight-700">Search Reports</h5>
            <Row>
              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="tpa">Third Party Administrator</Label>
                  <ThirdPartyAdmin
                    value={thirdPartyAdminID}
                    name="thirdPartyAdminID"
                    onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value, setFieldValue, tpa)
                    }
                  />
                  {(tpaError.length > 0) ? (<div className="text-danger f-12">
                    {tpaError}
                  </div>) : null}
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                <FormGroup>
                  <Label for="coveredEntity">Covered Entity</Label>
                  {/* <CoveredEntity
                  thirdPartyAdminID={thirdPartyAdminID}
                  onSelect={(value)=>handleCEChange(value,setFieldValue)}
                  selectedCE={coveredEntity}
                  /> */}

                  <ReactSelect
                    name="ceDatalist"
                    options={ceDatalist}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handleCEChange}
                    value={selectedOption.optionSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} xs={3} xl={3}>
                {" "}
                {/* <FormGroup>
                  <Label for="pharmacy">Pharmacy</Label>
                  <Select
                    className="form-field-large inner-shadow-field" 
                    classNamePrefix="select"
                    isMulti
                    IndicatorSeparator
                    isClearable={true}
                    isSearchable={true}
                    placeholder="Enter PH NPI Or Store# Or PH Name"
                    name="color"
                    value={pharmacy}
                    onChange={(val)=>handlePharmacyChange(val,setFieldValue)}
                    options={reports.pharmacies}
                    inputValue={searchPHterm}
                    onInputChange={findPH}
                    getOptionLabel={(option) => option.description}
                    getOptionValue={(option) => option.id}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                    }}
                  />
                </FormGroup> */}
                <FormGroup>
                  <Label for="pharmacy">Pharmacy</Label>
                  {/* <Pharmacy
                  thirdPartyAdminID={thirdPartyAdminID}
                  coveredEntityID={coveredEntityID}
                  onSelect={(value)=>handlePHChange(value,setFieldValue)}
                  selectedPH={pharmacy}
                  /> */}
                  <ReactSelect
                    name="pharmacyData"
                    options={pharmacyData}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    optionSelected={true}
                    components={{
                      Option,
                      ValueContainer: LimitedChipsContainer,
                    }}
                    isSearchable="true"
                    onChange={handlepharmacyChange}
                    value={selectedOpt.optSelected}
                    className="claim_info"
                    maxMenuHeight={220}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 99,
                      }),
                      option: (provided) => ({
                        ...provided,
                        display: 'flex',
                        alignItems: 'flex-start',
                      })
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} sm={3} xs={3}>
                {" "}
                <FormGroup>
                  <Label for="reportType">Report</Label>
                  <Field
                    name="reportType"
                    className="required"
                    type="text"
                    autoComplete="off"
                    value={selectedReportType}
                    component={FormikSelectField}
                    //defaultoption = {reportOpt[0].label}
                    //  show={true}
                    options={reportOpt}
                    onChange={(val) => handleReportType(val, setFieldValue)}
                    keys={{
                      id: "id",
                      label: "label",
                    }}
                  />
                  {(reportsError.length > 0) ? (<div className="text-danger f-12">
                    {reportsError}
                  </div>) : null}
                </FormGroup>

              </Col>
            </Row>
            <Row>
              {selectedReportType === 1 ? (
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="claimType">Claim Type</Label>
                    <Field
                      name="claimType"
                      type="text"
                      autoComplete="off"
                      value={selectedClaimType}
                      component={FormikSelectField}
                      show={true}
                      options={claimTypeOpt}
                      onChange={(val) => handleClaimType(val, setFieldValue)}
                      defaultoption="--Select--"
                      keys={{
                        id: "Id",
                        label: "ClaimType",
                      }}
                    />
                  </FormGroup>
                </Col>
              ) : selectedReportType !== 6 ? (
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="statusType">Status Type</Label>
                    <Field
                      name="statusType"
                      type="text"
                      autoComplete="off"
                      value={statusTypeSelected}
                      component={FormikSelectField}
                      disabled={selectedReportType === 1 || selectedReportType === 6}
                      options={statusTypesOpt}
                      onChange={(val) => handleStatusType(val, setFieldValue)}
                      defaultoption="--Select--"
                      keys={{
                        id: "Id",
                        label: "StatusType",
                      }}
                    />
                  </FormGroup>
                </Col>
              ) : null}

              {selectedReportType === 6 && (
                <Col md={3} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="dateRange">Date Range</Label>
                    <Field
                      id="dateRange"
                      name="dateRange"
                      type="text"
                      component={FormikSelectField}
                      value={dateRangeValue}
                      options={dateRangeOption}
                      onChange={handleDateRangeChange}
                      keys={{
                        id: "id",
                        label: "label",
                      }}
                    />
                  </FormGroup>
                </Col>
              )}

              {(selectedReportType === 1 || selectedReportType === 2 || selectedReportType === 5) && (
                <Col md={3} sm={3} xs={3}>
                  <FormGroup>
                    <Label for="dateRange">Date Range</Label>
                    <Field
                      id="dateRange"
                      name="dateRange"
                      type="text"
                      component={FormikSelectField}
                      //show={true}
                      value={dateRangeValue}
                      options={dateRangeOption}
                      onChange={handleDateRangeChange}
                      //  defaultoption="--Select--"
                      keys={{
                        id: "id",
                        label: "label",
                      }}
                    />
                  </FormGroup>
                </Col>
              )}
              {displayCustomDate &&

                <Col md={3} sm={3} xs={3} className="pe-sm-4">
                  <Row>
                    <Col>
                      <FormGroup className="required-date">
                        <Label>Start Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <Field
                            type="text"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            placeholder="Select a date"
                            value={startDate}
                            show={true}
                            component={FormikDatePicker}
                            onChange={handleStartDate}
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("startDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {(startDateError.length > 0) ? (<div className="text-danger f-12">
                          {startDateError}
                        </div>) : null}
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="required-date">
                        <Label>End Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <Field
                            type="text"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            minDate={startDate ? new Date(startDate) : null}
                            placeholder="Select a date"
                            value={enddatevalue}
                            show={true}
                            component={FormikDatePicker}
                            onChange={handleEndDate}
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("endDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {(endDateError.length > 0) ? (<div className="text-danger f-12">
                          {endDateError}
                        </div>) : null}
                      </FormGroup>
                    </Col>{" "}

                  </Row>
                </Col>


              }




              <Col xs="auto" className="mt-3 pt-3">
                {" "}
                <FormGroup>
                  <Label className="pt-1"></Label>
                </FormGroup>
              </Col>
            </Row>
            <Row className="d-flex justify-content-end">
              <Col md="auto" className="pt-4 mt-1">
                <Label>{""}</Label>
                <Button
                  disabled={loading}
                  onClick={handleSubmit}
                  color="primary"
                  className="search ms-3"
                >
                  <span className="right_5">
                    <img src={searchicon} alt="" />
                  </span>{" "}
                  Search
                </Button>
                <Button className="reset" color="primary" onClick={() => handleReset(props)}>
                  <span className="right_5">
                    <img src={reset} alt="" />
                  </span>{" "}
                  Reset
                </Button>
              </Col>
            </Row>
          </div>
        );
      }}
    ></Formik>
  );
};

export default SearchReports;
